<template>
  <drag-dialog
    :visible.sync="visible"
    title="检测项目详情"
    width="900px"
    height="700px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <el-form :model="editForm" ref="editForm" label-width="120px" disabled>
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="检测项目" prop="itemName">
            <el-input v-model="editForm.itemName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测项目编码" prop="itemCode">
            <el-input v-model="editForm.itemCode" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测项目类型" prop="itemType">
            <el-select v-model="editForm.itemType">
              <el-option v-for="item in itemTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测标准" prop="basisNameTest">
            <el-input v-model="editForm.basisNameTest" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="质量标准" prop="basisNameQl">
            <el-input type="textarea" v-model="editForm.basisNameQl" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="技术指标" prop="tiText">
            <el-input type="textarea" v-model="editForm.tiText" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="关联检测依据" required>
            <el-table border :data="basisList" height="160" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
              <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
              <el-table-column
                prop="basisName"
                label="依据的标准名称及编号（含年号）"
                min-width="180"
                header-align="center"
              ></el-table-column>
              <el-table-column prop="fileName" label="关联文件" align="center">
                <template v-slot="{ row }">
                  {{ row.fileName }}
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getItem } from '@/api/system';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      editForm: {
        itemName: ''
      },
      basisList: [],
      deviceList: [],
      itemTypeOptions: [
        {
          label: '样品类',
          value: 0
        },
        {
          label: '方法类',
          value: 1
        }
      ],
      rules: {
        itemName: [{ required: true, message: '请输入', trigger: 'blur' }],
        itemCode: [{ required: true, message: '请输入', trigger: 'blur' }],
        itemType: [{ required: true, message: '请选择', trigger: 'blur' }]
      }
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      const { data } = await getItem({ id: this.activeId });

      this.editForm = {
        id: data.id,
        itemName: data.itemName,
        itemCode: data.itemCode,
        unitPrice: data.unitPrice,
        oriVersion: data.oriVersion,
        itemType: data.itemType,
        basisNameTest: data.basisNameTest,
        basisNameQl: data.basisNameQl,
        tiText: data.tiText
      };
      this.basisList = data.basisList ?? [];
      this.deviceList = data.deviceList ?? [];
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped></style>
